/** EMBER-DANDI's API and web UI. Production only: the proxies and OSB's MAABCD copy use it too. */
export const EMBER_API_ORIGIN = 'https://api-dandi.emberarchive.org'
export const EMBER_WEB_ORIGIN = 'https://dandi.emberarchive.org'
